// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialsInput_root__9sve_"};